export default class SignatureData {
    constructor(dto) {
        this.documentId = -1;
        this.useCertificate = false;
        this.useQualifiedSignature = false;
        this.certificatePassword = '';
        this.useImage = false;
        this.includeFrame = false;
        this.includeUserFullName = false;
        this.includeTimeStamp = false;
        this.selectedSignatureId = null;
        this.image = {
            x: 0,
            y: 0,
            width: 200,
            height: 100,
            page: 1
        };

        if (dto) {
            this.image = dto.image;
        }
    }

    toDto(pdfWidth, pdfHeight) {
        return {
            ObjectID: this.documentId,
            UseCertificate: this.useCertificate,
            CertificatePassword: this.certificatePassword,
            UseImage: this.useImage,
            UseQualifiedSignature: this.useQualifiedSignature,
            IncludeFrame: this.includeFrame,
            IncludeUserFullName: this.includeUserFullName,
            IncludeTimeStamp: this.includeTimeStamp,
            ImagePositionX: (this.image.x * 100) / pdfWidth,
            ImagePositionY: ((pdfHeight - this.image.y - this.image.height) * 100) / pdfHeight,
            ImageSizeX: (this.image.width / pdfWidth) * 100,
            ImageSizeY: (this.image.height / pdfHeight) * 100,
            OriginalImageSizeX: this.image.width,
            OriginalImageSizeY: this.image.height,
            Page: this.image.page,
            SelectedSignatureId: this.selectedSignatureId
        };
    }
}
